import { ICellRendererParams } from "ag-grid-community";
import "./Renderers.css";

export function SystemBalanceCellRenderer(params: ICellRendererParams) {
    if (params.node.group) {
        return params.value === "Inlet"
            ? "Inlets"
            : params.value === "Outlet"
                ? "Outlets"
                : "Other";
    }

    return params.value;
}
